import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getStarFilterInput = (searchCriteria: SearchCriteriaModel): number[] | null => {
  if (searchCriteria.star && searchCriteria.star.length > 0) {
    return searchCriteria.star.map(i => parseInt(i, 10)).filter(i => i);
  }

  return null;
};
